import React from 'react';
import { motion } from 'framer-motion';
import { FiAlertCircle, FiRefreshCw } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

// Lightweight, theme-token banner for weather-load failures on the results
// pages. Classifying the failure (rate-limited vs generic) is the caller's
// job; this just renders the message and an optional throttled retry.
export default function WeatherAlertBanner({
  message,
  onRetry = null,
  retrying = false,
  retryDisabled = false,
  retryLabel = null,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-lg border border-border-subtle bg-surface p-4"
    >
      <div className="flex items-start gap-3">
        <SafeIcon icon={FiAlertCircle} className="w-5 h-5 text-status-warning flex-shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <p className="text-sm text-text-secondary">{message}</p>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              disabled={retrying || retryDisabled}
              className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-accent hover:text-interactive-hover disabled:text-text-muted disabled:cursor-not-allowed transition-colors"
            >
              <SafeIcon icon={FiRefreshCw} className={`w-4 h-4 ${retrying ? 'animate-spin' : ''}`} />
              {retryLabel || (retrying ? 'Retrying' : 'Try again')}
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
}
